import React, { useState } from "react";
import "../../Css/InternalPages.css";

import { MdKeyboardArrowDown } from "react-icons/md";
import { MdOutlineKeyboardArrowUp } from "react-icons/md";

const faqs = [
  {
    question: "What do I need to sign up for a business account?",
    answer:
      "To get started, you simply need to provide your business name, GST number, mobile number, and pickup location details. Once submitted, our team verifies your info and activates your enterprise account within 24 hours — no hidden setup fees or paperwork hassles.",
  },
  { question: "How do recurring orders work?", answer: "" },
  { question: "Can I track multiple deliveries and vehicles at once?", answer: "" },
  { question: "Can I deliver to multiple customers in one trip?", answer: "" },
  { question: "Can I give my team access to manage bookings?", answer: "" },
  { question: "How is pricing calculated for deliveries?", answer: "" },
  { question: "What vehicle options are available for different parcel sizes?", answer: "" },
  { question: "Can I download invoices and reports for accounting?", answer: "" },
  { question: "Is there support for urgent or same-day deliveries?", answer: "" },
  { question: "What if I need help or face an issue during delivery?", answer: "" },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
  <section className="w-full bg-[#ececec]">
  <div className="mx-auto max-w-7xl">
    <div className="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-10 lg:px-8 ">
      <h2 className="mb-6 text-center text-[22px] font-semibold leading-tight sm:text-3xl md:text-[28px]  text-[#212529]">
        Frequently Asked Questions
      </h2>

      <div className="mx-auto w-full">
        {faqs.map((faq, index) => (
          <div
            key={index}
            onClick={() => toggleFAQ(index)}
            className={`mb-3 cursor-pointer overflow-hidden transition-all duration-300 ${
              openIndex === index
                ? "rounded-xl bg-[#fcf7e7]"
                : "border-b border-[#d8d8d8]"
            }`}
          >
            <div className="flex items-center justify-between gap-4 px-4 py-4 sm:px-5">
              <h3 className="m-0 text-[16px] font-medium leading-6 text-[#212529] sm:text-base md:text-lg">
                {faq.question}
              </h3>

              <span className="flex shrink-0 items-center justify-center text-2xl">
                {openIndex === index ? (
                  <MdOutlineKeyboardArrowUp />
                ) : (
                  <MdKeyboardArrowDown />
                )}
              </span>
            </div>

            {openIndex === index && (
              <div className="px-4 pb-5 pt-1 text-[14px] leading-7 text-gray-600 sm:px-5 sm:text-base">
                {faq.answer || <em>Answer coming soon...</em>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
    </section>
  );
}

export default FAQ;